import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from '../CommonModal/CommonModal';
import SaveBuildModalContent from './SaveBuildModalContent';
import { contentMaxHeightDifference } from '../CommonModal/CommonModal.styles';
const SaveBuildModal = ({ showModal, handleSaveBuildSubmit, handleCrossIconClick, handleCloseModal, modelImage, bigExteriorImage, nameBadge, isProcessing, buildName, setBuildName, defaultBuildName, vehicle, }) => {
    const { t } = useTranslation();
    return (_jsx(CommonModal, { handleCrossIconClick: handleCrossIconClick, handleCloseModal: handleCloseModal, handleSubmit: handleSaveBuildSubmit, showModal: showModal, submitButtonEnabled: !isProcessing, dataTestId: "cy-SaveBuildModal", primaryButtonText: t('Pages.Bap.saveButton'), secondaryButtonText: t('Pages.Bap.doNotSaveButton'), title: t('Pages.Bap.saveBuildModalHeading'), childrenProps: {
            otherStyles: {
                maxHeight: contentMaxHeightDifference.map(value => `calc(100vh - ${value})`),
                overflowY: 'auto',
            },
        }, children: _jsx(SaveBuildModalContent, { vehicleImage: modelImage, modelBadgeImage: nameBadge, vehicle, buildName, bigExteriorImage, setBuildName, inputPlaceholder: defaultBuildName }) }));
};
export default SaveBuildModal;
